export function formatPhone(phone) {
  return phone.replaceAll(' ','').replaceAll('-','').replaceAll('(','').replaceAll(')','');
}
